import React, { Component } from "react";

class SentMessagesRowRO extends Component {
  render() {
    //console.log("SentMessagesRow: " + this.props.sentmessage[0]);
    let datestring = new Date(this.props.sentmessage[0])
      .toLocaleString("en-GB", {
        timeZone: "UTC"
      })
      .split(",");
    return (
      <tr>
        <td>{datestring[0]}</td>
        <td>{datestring[1]}</td>
        <td>{this.props.sentmessage[1]}</td>
      </tr>
    );
  }
}

export default SentMessagesRowRO;
